<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/user/profile' }"
        >个人中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>修改个人信息</el-breadcrumb-item>
    </el-breadcrumb>
    <back-box>
      <div class="update-info-box">
        <el-form ref="form" :model="user" :rules="rules" label-width="100px">
          <el-form-item label="用户昵称">
            <el-input
              v-model="user.nickName"
              placeholder="长度在6到20个字符"
              maxlength="20"
            >
              <div slot="suffix">{{ nameLength }}/20</div>
            </el-input>
          </el-form-item>
          <el-form-item label="用户头像">
            <user-avatar></user-avatar>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="user.phonenumber"
              placeholder="请输入手机号"
              maxlength="11"
            >
              <div slot="suffix">{{ phoneLength }}/11</div>
            </el-input>
          </el-form-item>
          <el-form-item label="邮  箱">
            <el-input
              v-model="user.email"
              placeholder="请输入邮箱"
              maxlength="20"
            >
              <div slot="suffix">{{ emailLength }}/20</div>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="onSubmit"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </back-box>
  </div>
</template>

<script>
import backBox from "../../../components/backBox";
import userAvatar from "../components/userAvatar";
import { updateUserProfile } from "@/api/system/user";
import store from "@/store";
export default {
  components: { userAvatar, backBox },
  // 定义属性
  data() {
    return {
      user: {},
      nameLength: 0,
      phoneLength: 0,
      emailLength: 0,
      // 表单校验
      rules: {
        nickName: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" },
        ],
        email: [
          { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        phonenumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {
    user: {
      handler: function (val) {
        this.nameLength = val.nickName.length;
        this.phoneLength = val.phonenumber.length;
        this.emailLength = val.email.length;
      },
      deep: true,
    },
  },
  // 方法集合
  methods: {
    onSubmit() {
      this.$set(this.user, "avatar", store.getters.avatar),
        this.$set(this.user, "userId", store.getters.userId);
      console.log(this.user);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          updateUserProfile(this.user).then((response) => {
            if (response.code === 200) {
              this.msgSuccess("修改成功");
            }
          });
        }
      });
    },
    getRouteQuery() {
      let query = this.$route.query;
      this.$set(this.user, "nickName", query.nickName);
      this.$set(this.user, "phonenumber", query.phonenumber);
      this.$set(this.user, "email", query.email);
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log('store',store.gettersuserId);
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getRouteQuery()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss'>
.update-info-box {
  margin: 60px 30px;
  .el-form-item {
    margin-bottom: 40px;
  }
  .el-form-item__content {
    width: 400px !important;
    text-align: left;
  }
  .el-input__inner {
    height: 40px;
    background-color: rgba(28, 54, 89, 0.2);
    border-radius: 2px;
    color: white;
    border: solid 2px #dddddd !important;
  }
  .el-form-item__label {
    text-align: center;
  }
  .btn {
    width: 120px;
    height: 46px;
    background-color: #e88634;
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    border: none;
  }
}
</style>
